import { UserOutlined } from "@ant-design/icons";
import { Avatar, Flex } from "antd";
import { shallowEqual } from "react-redux";

import { useAppSelector } from "@/hooks";
import { PrimaryText } from "@/shared/ui";
import { getFileUrl } from "@/utils";

interface ProfileSummaryBlockProps {
    onOpenChangePhoto: () => void;
}

export const ProfileSummaryBlock = ({
    onOpenChangePhoto,
}: ProfileSummaryBlockProps) => {
    const { email, fullName, photo } = useAppSelector(
        (s) => ({
            email: s.user.email,
            fullName: `${s.user.firstName} ${s.user.lastName}`,
            photo: s.user.photo,
        }),
        shallowEqual,
    );

    const photoUrl = photo ? getFileUrl(photo) : null;

    return (
        <Flex gap={8} style={{ marginBottom: 32 }}>
            <Avatar
                size={80}
                icon={<UserOutlined />}
                src={photoUrl}
                onClick={onOpenChangePhoto}
            />

            <Flex vertical gap={4}>
                {email && <PrimaryText fontSize={16}>{email}</PrimaryText>}

                <PrimaryText fontSize={16}>{fullName}</PrimaryText>
            </Flex>
        </Flex>
    );
};
